export enum QMIcon {
	RIGHT_ARROW = 'https://assets.quickorder.dk/qm/icons/left-arrow.svg',
	LEFT_ARROW = 'https://assets.quickorder.dk/qm/icons/right-arrow.svg',
	PLUS = 'https://assets.quickorder.dk/qm/icons/plus.svg',
	PLANE = 'https://assets.quickorder.dk/qm/icons/plane.svg',
	PUNCH_CLOCK_WHITE = 'https://assets.quickorder.dk/qm/icons/punch-clock-white.svg',
	DOLLAR_SIGN_WHITE = 'https://assets.quickorder.dk/qm/icons/dollar-sign-white.svg',
	DOLLAR_SIGN_GOLDEN_BROWN = 'https://assets.quickorder.dk/qm/icons/dollar-sign-golden-brown.svg',
	EXCHANGE_ARROWS_WHITE = 'https://assets.quickorder.dk/qm/icons/exchange-arrows-white.svg',
	VIEW_GREY2 = 'https://assets.quickorder.dk/qm/icons/view-grey2.svg',
	VIEW_CANCEL_GREY2 = 'https://assets.quickorder.dk/qm/icons/view-cancel-grey2.svg',
	ALERT_WHITE = 'https://assets.quickorder.dk/qm/icons/alert-white.svg',
}
